"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styles = require("@material-ui/core/styles");

var _typography = _interopRequireDefault(require("../typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(_ref) {
  var _objectSpread2;

  var mixins = _ref.mixins,
      spacing = _ref.spacing,
      breakpoints = _ref.breakpoints;
  return {
    root: _objectSpread({}, mixins.flex('center', 'space-between'), (_objectSpread2 = {
      minHeight: 36
    }, _defineProperty(_objectSpread2, breakpoints.down('sm'), {
      marginBottom: spacing(3)
    }), _defineProperty(_objectSpread2, breakpoints.up('md'), {
      marginBottom: spacing(4)
    }), _objectSpread2)),
    actions: _objectSpread({}, mixins.flex('center')),
    title: {
      textTransform: 'capitalize'
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback


var PageHeader = _react.default.forwardRef(function PageHeader(props, ref) {
  var classes = props.classes,
      title = props.title,
      actions = props.actions;

  var pageTitleEl = _react.default.createElement(_typography.default, {
    classes: {
      root: classes.title
    },
    variant: "headline",
    component: "h1"
  }, title);

  return _react.default.createElement("header", {
    className: classes.root,
    ref: ref
  }, typeof title === 'string' ? pageTitleEl : title, actions && _react.default.createElement("div", {
    className: classes.actions
  }, actions));
});

exports.PageHeader = PageHeader;
process.env.NODE_ENV !== "production" ? PageHeader.propTypes = {
  classes: _propTypes.object.isRequired,
  title: _propTypes.node.isRequired,
  actions: _propTypes.node
} : void 0;
PageHeader.defaultProps = {
  actions: null
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'PageHeader'
})(PageHeader);

exports.default = _default;